<template>
    <main>
        <div class="toolHeader"></div>
        <div class="main__column shiftUp">
            <ResultsTable :recommendations="$route.params.recommendations" />
        </div>
        <div class="main__column">
            <SkillsCloud :skills="$route.params.skills" />
        </div>
    </main>
</template>

<script>
import ResultsTable from './ResultsTable';
import SkillsCloud from './SkillsCloud';
export default {
    name: 'Results',
    components: {
        ResultsTable,
        SkillsCloud,
    },
};
</script>

<style lang="less" scoped>
a.backButton {
    color: inherit;
    text-decoration: none;
    position: absolute;
    top: 3em;
    &:hover {
        color: #2aacea;
    }
    i {
        margin-right: 6px;
    }
}
p {
    margin-bottom: 0;
    max-width: 800px;
    margin: auto;
}
.results__tagline {
    margin-bottom: 2em;
}
</style>
